var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialemail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23.5C18.0751 23.5 23 18.5751 23 12.5C23 6.42487 18.0751 1.5 12 1.5C5.92487 1.5 1 6.42487 1 12.5C1 18.5751 5.92487 23.5 12 23.5ZM6.5 10C6.5 9.17157 7.17157 8.5 8 8.5H16C16.8284 8.5 17.5 9.17157 17.5 10V14.5C17.5 15.3284 16.8284 16 16 16H8C7.17157 16 6.5 15.3284 6.5 14.5V10ZM7.5 14.5V10.3161L8.771 11.4238L10.8735 13.2561C11.2786 13.6088 11.7135 13.7 12 13.7C12.2863 13.7 12.7213 13.6091 13.1265 13.2563L15.2291 11.424L16.5 10.3164V14.5C16.5 14.7761 16.2761 15 16 15H8C7.72386 15 7.5 14.7761 7.5 14.5ZM8.08563 9.5H15.9147L14.572 10.6702L12.4699 12.5021C12.2756 12.6713 12.0862 12.7 12 12.7C11.9141 12.7 11.7246 12.6712 11.5301 12.5019L9.42802 10.67L8.08563 9.5Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialemail);
export default __webpack_public_path__ + "static/media/Social email.fdab24c152bffca397db88c55d6b1e26.svg";
export { ForwardRef as ReactComponent };